<template>
    <div class="content">
        <div class="search">
            <el-button type="success" style="background-color: #2FBC82;" class="el-icon-s-ticket" @click="AddClick">派发优惠券</el-button>
            <JsonExcel :fields="exportDataStandard" :data="exportData" type="xls" name="用券明细" :fetch="createExportData" :before-finish="finishDownload" worksheet="用券明细">
                <el-button type="primary" class="el-icon-download" style="background-color: #2FBC82;margin-left: 15px;"> 导出</el-button>
            </JsonExcel>
        </div>

        <el-card style="width:100%;height: 90px;display: flex;flex-direction: column;justify-content: center;" class="box-card">
          <el-row :gutter="10">
            <el-col :xs="12" :sm="8" :md="6" :lg="4" :xl="4">
              <div class="search" style="margin-left: 10px;">
                <label>商家</label>
                <el-select v-model="searchForm.mc_id" style="min-width:150px">
                    <el-option label="全部" :value="0"></el-option>
                    <el-option v-for="item in merDataList" :key="item.mc_id" :label="item.mc_name" :value="item.mc_id"></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :xs="12" :sm="8" :md="6" :lg="4" :xl="4">
              <div class="search">
                <label>优惠券</label>
                <el-select v-model="searchForm.dis_Id" style="min-width:150px">
                    <el-option label="全部" :value="0"></el-option>
                    <el-option v-for="item in disDataList" :key="item.dr_id" :label="item.dr_name" :value="item.dr_id"></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :xs="12" :sm="8" :md="12" :lg="8" :xl="8">
              <div class="search">
                <label>时间</label>
                <el-date-picker v-model="searchForm.time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
              </div>
            </el-col>
            <el-col :xs="12" :sm="8" :md="6" :lg="4" :xl="4">
              <div class="search">
                <label >车牌号</label>
                <el-input v-model="searchForm.plateno" style="width: 200px;"></el-input>
              </div>
            </el-col>
            <el-col :xs="12" :sm="8" :md="6" :lg="4" :xl="4">
              <div class="search">
                <el-button type="primary" plain @click="Search">查询</el-button>
              </div>
            </el-col>
          </el-row>
        </el-card>

        <el-table :data='LogDataList' border style="width: 100%;font-size:13px" stripe :highlight-current-row='true'>
            <el-table-column align="center" prop="log_opt_time" label="折扣时间">
                <template slot-scope="scope">
                    {{FormateTime(scope.row.log_opt_time)}}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="log_plateno" label="车牌号"></el-table-column>
            <el-table-column align="center" prop="log_in_time" label="入场时间">
                <template slot-scope="scope">
                    {{FormateTime(scope.row.log_in_time)}}
                </template>
            </el-table-column>
             <el-table-column align="center" prop="mc_name" label="商家名称"></el-table-column>
             <el-table-column align="center" prop="dr_name" label="优惠券"></el-table-column>
             <el-table-column align="center" prop="log_state" label="使用状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.log_state === 0 ? 'danger' : 'success'" disable-transitions>
                        {{scope.row.log_state===0?'未使用':(scope.row.log_state===1?'已使用':'已退回')}}
                    </el-tag>
                  </template>
             </el-table-column>
        </el-table>
        <el-pagination style="width:100%" layout="prev, pager, next" @current-change="current_change" :total="total" background :page-size="searchForm.pageSize"></el-pagination>
    
    
        <el-dialog v-if="dialogVisible" title="派发优惠券" :visible.sync="dialogVisible" width='600px' :append-to-body='true'>
          <div>
            <div class="search" style="justify-content:space-around;">
              <div class="a" :class="[checkType===0?'check':'uncheck']"  @click='CheckType(0)'>手动发券</div>
              <div class="a" :class="[checkType===1?'check':'uncheck']" @click='CheckType(1)'>扫码发券</div>
            </div>
            <div style="margin-top: 50px;">
              <div v-if="checkType===0" class="search" style="margin-left: 20px;">
                <span style="width: 55px;margin-left: 30px;">车牌号：</span>
                <el-input v-model='DistributeForm.plateno' style="width: 250px;"></el-input>
              </div>
              <div style="margin-bottom: 10px;margin-left: 20px;">
                <span>使用优惠券： </span>
                <el-select v-model="DistributeForm.dis_Id" style="width:250px">
                  <el-option v-for="item in MerBalanceDataList" :key="item.md_dr_id" :label="item.dr_name" :value="item.md_dr_id"></el-option>
                </el-select>
              </div>
              <div v-if="checkType===1" class="content" style="margin-left: 20px;">
                <div style="margin-bottom: 10px;">
                  <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;派发张数：</span>
                  <el-input-number v-model='DistributeForm.dis_num' controls-position="right" :precision="0" :min="1" style="width:250px"></el-input-number>
                </div>
                <div>
                  <span>扫码有效期： </span>
                  <el-input-number v-model='DistributeForm.dis_timeLen' controls-position="right" :precision="0" :min="1" style="width:250px"></el-input-number>分钟
                </div>
              </div>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="submit">确 定</el-button>
          </span>
        </el-dialog>



        <el-dialog v-if="qrDialogVisible" title="动态扫码优惠" :visible.sync="qrDialogVisible" width='500px' :append-to-body='true' @close='close'>
          <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
            <VueQr :text="url" :size="280" :logoScale="0.2" ></VueQr>
            <span>有效时间：<span style="color: red;">{{balanceTime}}</span></span>
          </div>
          <span slot="footer" class="dialog-footer">
              <el-button @click="qrDialogVisible = false;close()">取 消</el-button>
          </span>
        </el-dialog>



      </div>
</template>

<script>
import util from '../../../util/util'
import JsonExcel from 'vue-json-excel'
import VueQr from 'vue-qr'




export default {
  data: function () {
    return {
      searchForm: {
        mc_id: 0,
        dis_Id: 0,
        time: [],
        plateno:'',
        status: 0,
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      merDataList: [],
      disDataList: [],
      LogDataList: [],

      MerBalanceDataList:[],//商家剩余额度信息

      dialogVisible:false,
      checkType:0,
      DistributeForm:{
        plateno:'',
        dis_Id:0,
        mc_id:0,
        dis_num:1,
        dis_timeLen:3
      },


      qrDialogVisible:false,
      url:'',
      timer:null,
      balanceTime:'',

      // 导出
      exportDataStandard: {
        折扣时间: {
          field: 'log_opt_time',
            callback: value => {
              return this.FormateDate(value)
          }
        },
        车牌号: 'log_plateno',
        入场时间: {
          field: 'log_in_time',
            callback: value => {
              return this.FormateDate(value)
          }
        },
        商家名称: 'mc_name',
        优惠券: 'dr_name',
        使用状态: {
          field: 'log_state',
          callback: value => {
            return value === 0 ? '未使用' : (value === 1? '已使用':'已退回')
          }
        }
      },
      exportData: []
    }
  },
  components: {
    JsonExcel,
    VueQr
  },
  computed: {
    FormateTime () {
      return function (time) {
        return util.FormateDate(time, 2)
      }
    }
  },
  created () {
    util.Get("merchant/getmerchantDataList").then(res=>{
      if(res.rpStatus===10000){
        this.merDataList = res.list
      }
    })
    util.Get("disrules/getdisrulesdatalist").then(res=>{
      if(res.rpStatus===10000){
        this.disDataList = res.list
      }
    })

    let user = util.JesToken()
    this.DistributeForm.mc_id=(user.user_type===5?0:user.user_mer_id)
    util.Get('merchant/getmerremainbalance?id='+this.DistributeForm.mc_id).then(res=>{
      this.MerBalanceDataList=res.list
    })
    this.GetDataList()
  },
  methods: {
    GetDataList () {
      this.searchForm.begintime=''
      this.searchForm.endtime=''
      if (this.searchForm.time!==null&& this.searchForm.time.length > 0) {
        this.searchForm.begintime = this.searchForm.time[0]
        this.searchForm.endtime = this.searchForm.time[1]
      }
      util.Get('logdiscountdetail/getlogdisdetaildataList', this.searchForm).then(res => {
        if (res.rpStatus === 10000) {
          this.LogDataList = res.list
          this.total = res.total
        }
      })
    },
    Search () {
      this.GetDataList()
    },
    current_change (page) {
      this.searchForm.pageNo = page
      this.GetDataList()
    },
    
    
    //派发优惠券
    AddClick(){
      this.dialogVisible=true
      this.checkType=0
      if(this.MerBalanceDataList.length>0){
        this.DistributeForm.dis_Id= this.MerBalanceDataList[0].md_dr_id
      }
      this.DistributeForm.plateno=''
      this.DistributeForm.dis_num=1
      this.DistributeForm.dis_timeLen=3
    },
    CheckType(value){
      this.checkType=value
    },
    submit(){
      this.DistributeForm.opt_type=this.checkType
      if(this.checkType===0){
        util.Post('logdiscountDetail/discount',this.DistributeForm).then(res=>{
          if(res.rpStatus===10000){
            this.$message.success(res.rpMsg);
            this.dialogVisible=false
          }else{
            this.$message.error(res.rpMsg)
          }
        })
      }
      if(this.checkType===1){
        util.Post('logdiscountDetail/createcode',this.DistributeForm).then(res=>{
          if(res.rpStatus===10000){
            this.url='https://pay.yundiankong.com/discount?code='+res.rpMsg
            this.balanceTime=''
            this.qrDialogVisible=true
            this.timerInterval(this.DistributeForm.dis_timeLen)
          }
        })
      }
    },

    timerInterval(timeLen){
      if(this.timer)
        this.close()
      let t=timeLen*60
      this.timer = setInterval(() => {
        t-=1
        let t1= Math.floor(t/60)
        let t2=t%60
        let t3=''
        if(t1>0)
          t3=t1+'分'
        if(t2>0)
          t3+=t2+'秒'
        this.balanceTime=t3
        console.log('aaaaa')
      }, 1000);
    },
    close(){
      clearInterval(this.timer)
    },


    
    
    
    // 导出
    async createExportData () {
      this.searchForm.pageNo = 0
      var form = JSON.parse(JSON.stringify(this.searchForm))
      form.pageNo = 0

      var result = await util.Get('logdiscountdetail/getlogdisdetaildataList', form)
      if (result.rpStatus === 10000) {
        this.exportData = result.list
        return this.exportData
      }
    },
    finishDownload () {
      this.$message({
        message: '导出数据成功',
        type: 'success'
      })
    }
  }
}
</script>

<style scoped>
.content{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}



.search{
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 13px;
  margin-bottom: 10px;
}
.search label{
  margin-right: 8px;

}
.a{
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 15px;
}
.check{
  border: 1px solid #27d089;
  color: #27d089;
}
.uncheck{
  border: 1px solid #ccc;
  color: black;
 
}




.el-table{
    margin-top: 10px;
}
</style>
